import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs/index';
import { catchError, tap } from 'rxjs/internal/operators';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  redirectUrl: string;
	err: any;
    apiUrl;
	username;
	password;
    httpOptions;

  constructor(private http: HttpClient, private envService: EnvironmentService) {
    this.apiUrl = this.envService.read('apiUrl');
		this.username = this.envService.getCredential('username');
		this.password = this.envService.getCredential('password');
        this.setHttpHeaders();
   }

   setHttpHeaders() {
    this.httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
    'Authorization': `Basic ${btoa(this.username + ':' + this.password)}`
        })
    };
}


getApplicationList(args): Observable<any> {		
    return this.http.post<any>(`${this.apiUrl}/application/list`,args,
        this.httpOptions).pipe(
            tap(),
            catchError(this.handleError('getApplicationList', this.err))
        );
}


getConnectorsList(args): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/dashboard/connectors/in/application`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getConnectorsList', this.err))
      );
}

getDashboardChartSentDetails(args): Observable<any> {		
  return this.http.post<any>(`${this.apiUrl}/dashboard/sent/details`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getDashboardSentDetails', this.err))
      );
}

getDashboardChartReceivedDetails(args): Observable<any> {		
  return this.http.post<any>(`${this.apiUrl}/dashboard/received/details`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getDashboardReceivedDetails', this.err))
      );
}

getDashboardChartTemplateDetails(args): Observable<any> {		
  return this.http.post<any>(`${this.apiUrl}/dashboard/connector/sent/template/details`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getDashboardReceivedDetails', this.err))
      );
}

getYearCount(args): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/dashboard/yearly/count`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getYearCount', this.err))
      );
}

getMonthlyCount(args): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/dashboard/monthly/count`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getMonthlyCount', this.err))
      );
}

getMonthlyReceivedCount(args): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/dashboard/monthly/received/count`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getMonthlyReceivedCount', this.err))
      );
}

getApplicationTotalMessageCount(args): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/application/messages/sent/count`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getApplicationTotalMessageCount', this.err))
      );
}

getApplicationMessageReceivedCount(args): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/application/messages/received/count`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getApplicationMessageReceivedCount', this.err))
      );
}

getReceivedCountByConnectors(args): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/application/connector/received/count`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getApplicationMessageReceivedCount', this.err))
      );
}
/**
* Handle Http operation that failed.
* Let the app continue.
* @param operation - name of the operation that failed
* @param result - optional value to return as the observable result
*/
private handleError<T>(operation = 'operation', result?: T) {
  return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error on operation', operation, error); // log to console instead

      // TODO: better job of transforming error for user consumption
      // this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
  };
}
}
